import React from 'react';
import { appVersion } from '../../config/AppVersion';

const Footer = () => {
  return (
    <div
      className="d-flex justify-content-between align-items-center w-100"
      style={{
        position: 'fixed',
        left: 0,
        bottom: 0,
        width: '100%',
        zIndex: 1030,
        minHeight: '40px',
        height: '40px',
        background: 'linear-gradient(0deg, rgb(7, 99, 7) 0%, rgb(7, 59, 43) 100%)',
        color: '#fff',
        padding: '4px 12px',
      }}
    >
      <div className="container-fluid d-flex justify-content-between align-items-center small" style={{height: '100%'}}>
        <p className="mb-0 flex-grow-1 text-center" style={{fontWeight: 'bold'}}>
          © {new Date().getFullYear()} - I & J Serviços de Consultoria em TI - Todos os direitos reservados.
        </p>
        <p className="mb-0 ms-3">{appVersion}</p>
      </div>
    </div>
  );
};

export default Footer;